import {makeApiSortParam} from './apiSortParams';

/**
 * Injects an alphabetical sort into a search params object.
 * @param obj - The object to inject the alphabetical sort into.
 * @param prop - The property to sort by.
 * @returns The object with the alphabetical sort injected.
 */
export function injectAlphabeticalSort<T extends Record<string, unknown>>(
  obj: T,
  prop = 'name'
): T {
  if (obj.orderBy) return obj;

  return {...obj, orderBy: makeApiSortParam({prop, isAsc: true})};
}

export function injectRecentSort<T extends Record<string, unknown>>(
  obj: T,
  prop = 'modified'
): T {
  if (obj.orderBy) return obj;

  return {...obj, orderBy: makeApiSortParam({prop, isAsc: false})};
}
